import { render, staticRenderFns } from "./ModalChangeDelivery.vue?vue&type=template&id=22255748&scoped=true&lang=pug"
import script from "./ModalChangeDelivery.vue?vue&type=script&lang=js"
export * from "./ModalChangeDelivery.vue?vue&type=script&lang=js"
import style0 from "./ModalChangeDelivery.vue?vue&type=style&index=0&id=22255748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22255748",
  null
  
)

export default component.exports